
export default {
  mapForm: {
    'placesAndDirections': 'Hely & útvonal',
    'isochrones': 'Elérhetőség',
    'uploadedContentRendered': 'Feltöltött tartalom megjelenítve',
    'errorRenderingContentUploaded': 'Hiba történt a feltöltött tartalom megjelenítésekor. Ellenőrizze a fájl formátumát és tartalmát'
  }
}
